import { render } from "./CellApprovalV2.vue?vue&type=template&id=7e316c31"
import script from "./CellApprovalV2.vue?vue&type=script&lang=js"
export * from "./CellApprovalV2.vue?vue&type=script&lang=js"

import "./CellApprovalV2.vue?vue&type=style&index=0&id=7e316c31&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/CellApprovalV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e316c31"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e316c31', __exports__)) {
    api.reload('7e316c31', __exports__)
  }
  
  module.hot.accept("./CellApprovalV2.vue?vue&type=template&id=7e316c31", () => {
    api.rerender('7e316c31', render)
  })

}


export default __exports__